export default "__VITE_ASSET__B_k3LMye__"